import React, { useEffect } from 'react'
import Button from '../../components/Button'
import { SVGInjector } from '@tanem/svg-injector'
import Modal from './Modal'
import { useBootstrapModal } from '../../utils/useForm'

export const useHelpTextModal = (props) => {
  const helpTextModal = useBootstrapModal(false)

  const MyHeader = (props) => (
    <h3>{'default header'}</h3>
  )

  const MyBody = (props) => (
    <p>{'default body'}</p>
  )

  const MyFooter = (props) => {

    const handleClose = (e) => {
      helpTextModal.closeModal()
    }

    useEffect(() => {
      const mySVGsToInject = document.querySelectorAll('img.injectSVG')
      SVGInjector(mySVGsToInject)
    }, [])

    return (
      <>
        <Button variant="primary" onClick={handleClose} disabled={false}>
          <span className="material-icons">close</span>
          <span className="button__text">{'Close'}</span>
        </Button>
      </>
    )
  }

  const HelpTextModalView = (props) => {
    const { header, body } = props

    return (
      <Modal
        className='-tbd'
        show={helpTextModal.value}
        onHide={helpTextModal.closeModal}
        header={header ? header : <MyHeader />}
        body={body ? body : <MyBody />}
        footer={<MyFooter />}>
      </Modal>
    )
  }

  return [ helpTextModal, HelpTextModalView ]
}
